import { render } from "./LeadAssigneeSelect.vue?vue&type=template&id=22642afe"
import script from "./LeadAssigneeSelect.vue?vue&type=script&lang=js"
export * from "./LeadAssigneeSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/LeadAssigneeSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22642afe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22642afe', __exports__)) {
    api.reload('22642afe', __exports__)
  }
  
  module.hot.accept("./LeadAssigneeSelect.vue?vue&type=template&id=22642afe", () => {
    api.rerender('22642afe', render)
  })

}


export default __exports__